import { render, staticRenderFns } from "./extra-register.vue?vue&type=template&id=7a83a390&scoped=true&lang=pug&"
import script from "./extra-register.vue?vue&type=script&lang=js&"
export * from "./extra-register.vue?vue&type=script&lang=js&"
import style0 from "./extra-register.vue?vue&type=style&index=0&id=7a83a390&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a83a390",
  null
  
)

export default component.exports